module.exports = __webpack_public_path__ + "static/d5-5918e10ef80a574699d7e84aab48a48f.png";